<template> 
  <div id="login">
		 <Header></Header>
     <div id="login-wrapper">
        <div id="login-area">
          <img src="~@/assets/login-bg.jpg" class="login-bg"/>
          <div class="login-form">
            <div class="lf-title">
              <div class="lf-sub-title">登录</div>
              <div class="lf-main-title">公共服务平台</div>
            </div>
            <div class="lf-item" style="margin-top: 52px;">
              <el-input v-model="loginForm.UserName" placeholder="用户名"></el-input>
            </div>
            <div class="lf-item">
              <el-input type="password" @keyup.enter.native="doLogin" v-model="loginForm.Password" placeholder="密码"></el-input>
            </div>
            <div class="lf-item">
              <el-input v-model="loginForm.yzm" placeholder="验证码"></el-input>              
              <img :src="codeImagePath" class="yzm" @click="getCodeImage"/>
            </div>
            
            <el-checkbox label="记住密码" v-model="isRemember"></el-checkbox>
            <div class="login-btn-area">
              <el-button type="primary" @click="doLogin">登录</el-button>
            </div>            
          </div>
      </div>
     </div> 
     <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { login, getIP, codeImage } from '@/api/api2.js'
import { Message } from 'element-ui'
  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {
        loginForm: {
          UserName: '',
          Password: '',
          yzm: '',
          Ip: ''
        },
        isRemember: false,
        codeImagePath: ''
      }
    },
    created() {
      localStorage.clear()
      this.getIP()
      console.log(this.$cookies.get('remember'))
      this.isRemember = this.$cookies.get('remember') == 1 ? true : false
      if(this.isRemember) {
        this.loginForm.UserName = this.$cookies.get('userName')
        this.loginForm.Password = this.$cookies.get('password')
      }
      this.getCodeImage()
    },
    methods: {
      getIP() {
        // getIP().then(res => {
        //   console.log(res.query)
        //     this.loginForm.Ip = res.query
        // })
      },
      doLogin() {
        if(!this.loginForm.UserName || !this.loginForm.Password) {
          Message({
            type: 'error',
            message: '用户名或密码不能为空'
          })
          return
        }
        login(this.loginForm).then(res => {
          if(res.error == 0) {
            const { token, EnterpriseName, UserName } = res.result
            localStorage.setItem('token', token)
            localStorage.setItem('accountName', UserName)
            localStorage.setItem('enterpriseName', EnterpriseName)
            this.$cookies.set('remember', this.isRemember ? 1 : 0,  '7d')
            if(this.isRemember) {
              this.$cookies.set('userName', this.loginForm.UserName, '7d')
              this.$cookies.set('password', this.loginForm.Password, '7d')
            }
            this.$router.push('/Home')
          }
        })
      },
      async getCodeImage() {
        const res = await codeImage({})
        this.codeImagePath = `data:image/Jpeg;base64,${res.result}`
        // this.loginForm.yzm = res.errmsg
      },
    },
    watch: {
			
    }
  }
</script>


<style>
  #login {
    height: 100%;
  }
  #login-wrapper {
    display: flex;
    justify-content: center;
  }
  #login-area {
    width: 1200px;
    display: flex;
  }
  .login-bg {
    width: 820px;
  }
  .login-form {
    background-color: #f8f9fe;
    width: 380px;
    padding: 40px 22px 0 22px;
  }

.lf-title {
  text-align: center;
}

.lf-sub-title {
  font-size: 18px;
  font-weight: bold;
}

.lf-main-title {
  margin-top: 6px;
  font-size: 22px;
}
.login-btn-area {
  margin-top: 150px;
}
</style>

<style scoped lang="less">
.login-form /deep/ .el-input__inner {
  border: none;
  background-color: transparent;
  border-bottom: 1px solid #e4e5e7;
  padding: 22px 12px;
}

.login-form /deep/ .el-checkbox {
  margin-top: 22px;
}

.login-form /deep/ .el-button {
  width: 100%;
}

.lf-item {
  position: relative;
  .yzm {
    position: absolute;
    right: 0;
    top: 5px;
    width: 100px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue